import { apiRequest } from '../apiRequest';
import { CANCEL_EXTEND_VIGNETTE_ENDPOINT } from '../urls';

export const extendCancelVignette = data => {
  return apiRequest('POST', CANCEL_EXTEND_VIGNETTE_ENDPOINT, data);
};
